import {
  CreateCompanyTagRequest,
  UpdateCompanyTagRequest,
  checkAddCompanyTag,
  checkRemoveCompanyTag,
  checkUpdateCompanyTag,
} from '@beeboard/common';
import { defineStore } from 'pinia';
import { useCompanyTagStore } from './companyTagStore';

export const useCompanyTagRulesStore = defineStore('companyTagRulesStore', {
  actions: {
    validateCreateCompanyTagRequest(payload: CreateCompanyTagRequest) {
      return checkAddCompanyTag(
        payload,
        useCompanyTagStore().companyTags.map((t) => t.title),
      );
    },

    validateUpdateCompanyTagRequest(
      payload: UpdateCompanyTagRequest,
      tagId: string,
    ) {
      return checkUpdateCompanyTag(
        payload,
        useCompanyTagStore()
          .companyTags.filter((t) => t.id !== tagId)
          .map((t) => t.title),
      );
    },

    validateRemoveCompanyTagRequest(tagId: string) {
      return checkRemoveCompanyTag(useCompanyTagStore().companyTag(tagId));
    },
  },
});
